'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var cx = require('classnames');
var AlloyButton = require('../alloy-button/AlloyButton.js');
var ChevronLeftIcon = require('../alloy-icon/ChevronLeftIcon.js');
var utils = require('./utils.js');
var modal_module = require('./modal.module.scss.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var cx__default = /*#__PURE__*/_interopDefault(cx);

var ChildModal = function (_a) {
    var _b;
    var backButtonMessage = _a.backButtonMessage, className = _a.className, children = _a.children, close = _a.close, focusSelector = _a.focusSelector, isOpen = _a.isOpen, title = _a.title, _c = _a.transitionTimeMS, transitionTimeMS = _c === void 0 ? 500 : _c;
    /**
     * internalIsOpen is needed to facilitate transitions. Otherwise the HTML would get
     * removed from the DOM before the transition finished
     */
    var _d = react.useState(isOpen), internalIsOpen = _d[0], setInternalIsOpen = _d[1];
    var _e = react.useState(''), transition = _e[0], setTransition = _e[1];
    var childModalRef = react.useRef(null);
    /**
     * Keeps isOpen in sync with internalIsOpen and handles transition
     */
    react.useLayoutEffect(function () {
        var handleAfterTransitionEffects = function () {
            setTransition(modal_module.default['open']);
            if (focusSelector) {
                utils.focusElement(childModalRef.current, focusSelector);
            }
        };
        var slideinTimeoutId;
        var afterSlideinTimeoutId;
        var afterSlideoutTimeoutId;
        if (isOpen) {
            setInternalIsOpen(true);
            // Force transition to happen after next JS cycle
            slideinTimeoutId = setTimeout(function () { return setTransition(modal_module.default['slidein']); });
            afterSlideinTimeoutId = setTimeout(handleAfterTransitionEffects, transitionTimeMS);
        }
        else {
            setTransition(modal_module.default['slideout']);
            afterSlideoutTimeoutId = setTimeout(function () { return setInternalIsOpen(isOpen); }, transitionTimeMS);
        }
        return function () {
            clearTimeout(slideinTimeoutId);
            clearTimeout(afterSlideinTimeoutId);
            clearTimeout(afterSlideoutTimeoutId);
        };
    }, [focusSelector, isOpen, transitionTimeMS]);
    /**
     * Hides content of modals which have a child model open.
     */
    react.useLayoutEffect(function () {
        var timeoutId;
        var resolvedParent = utils.getResolvedParent(childModalRef.current);
        if (internalIsOpen && resolvedParent) {
            /**
             * When a child modal opens, hide the parent modal's content
             * once the slidein transition finishes
             */
            timeoutId = setTimeout(function () { return resolvedParent.classList.add(modal_module.default['cat-modal--under-child']); }, transitionTimeMS);
        }
        else if (!isOpen && resolvedParent) {
            /**
             * When a child modal closes, display the parent mdoal's content
             * before the slideout transition starts
             */
            utils.childModalCleanup(resolvedParent);
        }
        return function () { return utils.childModalCleanup(resolvedParent, timeoutId); };
    }, [internalIsOpen, isOpen, transitionTimeMS]);
    if (!internalIsOpen)
        return null;
    return (jsxRuntime.jsxs("div", tslib.__assign({ className: cx__default.default(modal_module.default['cat-modal--child'], transition, className), ref: childModalRef }, { children: [jsxRuntime.jsx("div", tslib.__assign({ className: "back-btn-container" }, { children: jsxRuntime.jsxs(AlloyButton.AlloyButton, tslib.__assign({ buttonType: "ghost", className: cx__default.default('ms-n2 ps-0 d-flex align-items-center', (_b = {},
                        _b[modal_module.default['opened']] = isOpen,
                        _b)), onClick: close }, { children: [jsxRuntime.jsx(ChevronLeftIcon.default, { className: modal_module.default['cat-modal__back-icon'], height: 24, width: 24 }), jsxRuntime.jsx("span", tslib.__assign({ className: cx__default.default(modal_module.default['cat-modal__back-button-text'], 'my-0') }, { children: backButtonMessage }))] })) })), title && jsxRuntime.jsx("h2", tslib.__assign({ className: "h2 display-1 mb-4" }, { children: title })), children] })));
};
var ChildModal$1 = ChildModal;

exports.default = ChildModal$1;
//# sourceMappingURL=ChildModal.js.map
